(function ($) {
  const initializeBlock = function ($block) {
    const $carousel = $block.find(".logoGrid.logoGrid--slider");
    if($carousel.hasClass('slick-initialized'))
      $carousel.slick('unslick');
    $carousel.slick({
      arrows: false,
      dots: false,
      swipe: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 6000,
      pauseOnHover: false,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Reinitialize the slider when the window is resized
    $(window).on("resize", function () {
      $block.find(".logoGrid.logoGrid--slider").slick("resize");
    });
  };

  $(document).ready(function () {
    $(".block--logo-grid").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=logo-grid",
      initializeBlock
    );
  }
})(jQuery);
